import './index.scss'

import React, { useState, useEffect, useRef } from 'react'

import { DateTime } from 'luxon'
import Page from '../../../Components/Page'
import API, { RFCommand, RFPacket } from '../../../API'
import { Button, FormGroup, H5, InputGroup } from '@blueprintjs/core'

const AdminRFTools = () => {
	return (
		<Page title="Admin RF Tools" className="AdminRFToolsPage" icon="fa-solid fa-satellite-dish">
			<PacketSender />
			<RFLog />
		</Page>
	)
}

export default AdminRFTools

const PacketSender = () => {
	const [connections, setConnections] = useState(API.connections)
	const formRef = useRef(null)

	useEffect(() => {
		const subscribeToCommandBridge = async () => {
			try {
				await API.call('Admin.CommandBridge.Subscribe')
			} catch (error) {
				console.error('Failed to subscribe:', error)
			}
		}

		// Initial fetch
		subscribeToCommandBridge()

		// Set up interval for periodic fetching
		const intervalId = setInterval(subscribeToCommandBridge, 7000)

		return () => {
			clearInterval(intervalId)
		}
	}, [])

	useEffect(() => {
		setConnections(API.connections)
	}, [API.connections])

	const send = async () => {
		const formData = new FormData(formRef.current)

		const p = new RFPacket()
		p.sourceId = parseInt(formData.get('sourceId'), 10)
		p.destinationId = parseInt(formData.get('destinationId'), 10)
		p.command = parseInt(formData.get('command'), 10)
		p.data = Buffer.from(formData.get('payload'), 'hex')
		const hex = p.toRaw().toString('hex')

		let agentId = formData.get('gateway')
		const sendToAgents = []
		if (agentId == 'best') {
			// TODO
		} else if (agentId == 'all') {
			sendToAgents.push(...API.connections)
		} else {
			agentId = parseInt(agentId, 10)
			for (let con of API.connections) {
				if (con.id == agentId) {
					sendToAgents.push(con)
				}
			}
		}

		for (let con of sendToAgents) {
			await API.call('Admin.CommandBridge.Agent.Send', {
				agentId: con.id,
				type: 50,
				payloadHex: hex
			})
		}
	}

	const commandList = []
	for (let name in RFCommand) {
		const code = RFCommand[name]
		if (typeof code === 'number') {
			const nameStr = name + ' (#' + code + ')'
			commandList.push({ code: RFCommand[name], name: nameStr })
		}
	}

	return (
		<div className="PacketSender">
			<H5>Packet Sender</H5>
			<form ref={formRef}>
				<div className="Inputs">
					<FormGroup label="Gateway" labelFor="gateway">
						<select id="gateway" name="gateway">
							{/* <option value="best">Best</option> */}
							<option value="all">All</option>
							<option>-</option>
							{connections.map((con) => (
								<option value={con.id} key={`pscon${con.id}`}>
									{con.scanReport?.deviceId}
								</option>
							))}
						</select>
					</FormGroup>
					<FormGroup label="Source ID" labelFor="sourceId">
						<InputGroup id="sourceId" name="sourceId" defaultValue="123456" />
					</FormGroup>
					<FormGroup label="Destination ID" labelFor="destinationId">
						<InputGroup id="destinationId" name="destinationId" defaultValue="0" />
					</FormGroup>
					<FormGroup label="Command" labelFor="command">
						<select id="command" name="command">
							{commandList.map((c) => (
								<option value={c.code} key={c.code}>
									{c.name}
								</option>
							))}
						</select>
					</FormGroup>
				</div>
				<FormGroup label="Payload" labelFor="payload">
					<InputGroup id="payload" name="payload" placeholder="" />
				</FormGroup>
				<Button intent="primary" onClick={() => send()}>
					Send
				</Button>
			</form>
		</div>
	)
}

const RFLog = () => {
	const [packets, setPackets] = useState([])

	useEffect(() => {
		const listener = (p) => {
			setPackets((prevPackets) => [p, ...prevPackets])
		}

		API.addRFListener(null, null, listener)

		return () => {
			API.removeApiListener(null)
		}
	}, [])

	const clear = () => {
		setPackets([])
	}

	return (
		<div className="RFLog">
			<H5>
				Live Traffic <Button size="small" variant="minimal" icon="trash" onClick={clear} />
			</H5>
			<table className="bp5-html-table bp5-compact bp5-html-table-bordered bp5-html-table-striped">
				<thead>
					<tr>
						<th width="100">Time</th>
						<th width="70">Gateway</th>
						<th width="70">From</th>
						<th width="70">To</th>
						<th width="50">RSSI</th>
						<th>Command</th>
						<th>Payload</th>
					</tr>
				</thead>
				<tbody>
					{packets.map((p, i) => (
						<tr key={`rfpacket${i}`}>
							<td>{DateTime.fromMillis(p.timestamp ?? Date.now()).toFormat('HH:mm:ss.SSS')}</td>
							<td>{p.gatewayId}</td>
							<td>{p.sourceId}</td>
							<td>{p.destinationId}</td>
							<td>{p.rssi}</td>
							<td>
								{p.commandName} (#{p.command})
							</td>
							<td>{p.data.toString('hex')}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
